import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

interface TimelineItemProps {
    children: ReactNode
    /** Tailwind border-color class (e.g. "border-muted", "border-status-success").
     *  Defaults to "border-muted". Pass a custom class for semantic colours. */
    borderColorClass?: string
    className?: string
    'data-testid'?: string
}

const DEFAULT_BORDER_COLOR = 'border-muted'

export function TimelineItem({
    children,
    borderColorClass = DEFAULT_BORDER_COLOR,
    className,
    'data-testid': testId,
}: TimelineItemProps) {
    return (
        <div
            className={cn('border-l-2 pl-3 py-1', borderColorClass, className)}
            data-testid={testId}
        >
            {children}
        </div>
    )
}
